



































































































import { Component, Vue, Watch, PropSync, Prop } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import AdresseGouvResult from '@/models/AdresseGouvResult';
import AdresseGouvFeature from '@/models/AdresseGouvFeature';
import AutocompleteAddress from '@/components/AutocompleteAddress.vue';
import uniqBy from 'lodash/uniqBy';
import axios from 'axios';

interface Fields {
    street: {
        label: string;
        name: string;
        errorMessage?: string;
        required?: boolean;
    };
    street2: {
        label: string;
        name: string;
        errorMessage?: string;
    };
    postal_code: {
        label: string;
        name: string;
        errorMessage?: string;
        required?: boolean;
    };
    city: {
        label: string;
        name: string;
        errorMessage?: string;
        required?: boolean;
    };
    country: {
        label: string;
        name: string;
        errorMessage?: string;
        required?: boolean;
    }
    latitude: {
        label: string;
        name: string;
    };
    longitude: {
        label: string;
        name: string;
    }
}

@Component({
    components: {
        AutocompleteAddress,
    },
})
export default class Address extends Vue {
    @PropSync('fields', {
        default: () => {
            return {};
        },
    })
    pFields!: Fields;
    @PropSync('value', {
        default: () => {
            return {};
        },
    })
    pValue!: any;
    @PropSync('errors', {
        default: () => {
            return {};
        },
    })
    pErrors!: any;
    @PropSync('error', {
        default: () => {
            return {};
        },
    })
    pError!: any;

    submit() {
        this.$emit('submit');
    }

    onInput() {
        // Méthode pour gérer l'entrée dans le composant pays
        this.$emit('input', this.pValue);
    }

    // Méthode pour obtenir les messages d'erreur appropriés
    getErrorMessages(fieldName: string, defaultMessage: string): string[] {
        if (this.pErrors && this.pErrors[fieldName] && this.pErrors[fieldName].errors) {
            return this.pErrors[fieldName].errors;
        } else if (this.pError && this.pError[fieldName]) {
            return [defaultMessage];
        }
        return [];
    }

    formatSuggestAddress(item: AdresseGouvFeature) {
        return item.properties.name === item.properties.city
            ? `${item.properties.postcode} ${item.properties.city}`
            : `${item.properties.name}, ${item.properties.postcode} ${item.properties.city} `;
    }

    formatSuggestZip(item: AdresseGouvFeature) {
        return `${item.properties.postcode} ${item.properties.city}`;
    }

    formatSuggestCity(item: AdresseGouvFeature) {
        return `${item.properties.city} ${item.properties.postcode}`;
    }

    
        async searchAddress(value: string) {
                if (!value || value.trim() === '') {
                    return [];
                }

                // Changed URL
                const resp = await axios.get(
                        `https://data.geopf.fr/geocodage/search?q=${value}&autocomplete=1`
                    );
                    const data: AdresseGouvResult = await resp.data;
                    return data.features;
                }

            async searchZipAndCity(value: string) {
                    if (!value || value.trim() === '') {
                        return [];
                    }

                    // Changed URL
                    const resp = await axios.get(
                        `https://data.geopf.fr/geocodage/search?q=${value}&autocomplete=1`
                    );
                    const data: AdresseGouvResult = await resp.data;
                    // Logic remains exactly the same
                    const result = uniqBy(data.features, item => {
                        return `${item.properties.city} ${item.properties.postcode}`;
                    });
                    return result;
                }

    onItemAddress(item: AdresseGouvFeature) {
        this.pValue[this.pFields.street.name] =
            item.properties.name !== item.properties.city
                ? item.properties.name
                : '';
        this.pValue[this.pFields.postal_code.name] = item.properties.postcode;
        this.pValue[this.pFields.city.name] = item.properties.city;
        if (this.pFields.longitude && this.pFields.latitude) {
            this.pValue[this.pFields.longitude.name] = item.geometry.coordinates[0];
            this.pValue[this.pFields.latitude.name] = item.geometry.coordinates[1];
        }
    }

    handleCountryValidation(isValid: boolean) {
//   console.log("Address: handleCountryValidation appelé avec isValid =", isValid);
  // Ne pas utiliser this.pError directement, mais créer notre propre état d'erreur
  let countryName = '';
  if (this.pFields && this.pFields.country) {
    countryName = this.pFields.country.name;
  }
//   console.log("Address: Émission de country-error avec", { hasError: !isValid, fieldName: countryName });
  // Émettre un événement avec toutes les informations nécessaires
  this.$emit('country-error', {
    hasError: !isValid,
    fieldName: countryName
  });
  // Pour les logs de débogage
//   console.log("État final de pError[country] =", !isValid ? "true" : "undefined");
}

    onItemZipAndCity(item: AdresseGouvFeature) {
        this.pValue[this.pFields.postal_code.name] = item.properties.postcode;
        this.pValue[this.pFields.city.name] = item.properties.city;
    }
}
